import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import BouncingDotsLoader from "./LoadingDots";

const BookDownloadModal = (props: any) => {

  useEffect(()=> {
    console.log("book detail saved");
    props.setBookDetails(props.book);
  },[]);

  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        backdrop="static"
        keyboard={false}
        id="accessibility-modal"
        centered
      >
        <Modal.Header closeButton style={{ paddingBottom: 0 }}></Modal.Header>
        <Modal.Body className="modal-body">
          {
            props.isDownloading ? 
            (
              <div className="d-flex flex-column w-100">
                <h2 className="mb-2">Downloading book {props.book?.title}...</h2>
                <BouncingDotsLoader />
              </div>
            ) :
            (
              <div className="d-flex flex-column w-100">
                <div className="modal-title">
                  <Modal.Title style={{ justifyContent:'left' }}>Download Book {props.book?.title}</Modal.Title>
                </div>
                <div className="input-div-search mb-6 d-flex justify-center" style={{ width:'100%',backgroundColor:"white"}}>
                  <h2 id="output-format" className="form-label sr-only">
                    Select Book Format
                  </h2>
                  <select
                    className="form-control"
                    id="format"
                    name="format"
                    aria-label="Select Format"
                    value={props.selectedFormat}
                    onChange={(e) => props.setSelectedFormat(e.target.value)}
                    aria-labelledby="book-category"
                    required
                    style={{ width: '95%'}}
                  >
                    <option value="">Select Book Format</option>
                    {
                      props.category == "Telangana Books" ?
                      (
                        <option value="mp3">mp3</option>
                      ) : 
                      (  
                        <>
                          <option value="docx">docx</option>
                          <option value="html">html</option>
                          <option value="epub">epub</option>
                          <option value="mp3">mp3</option>
                        </>                 
                      )
                    }
                  
                  </select>
                </div>
                <Button variant="primary" onClick={()=>props.handleDownloadBtn(props.book)} style={{ marginLeft: '58%'}} className="button">
                  Download
                </Button>
              </div>
            )
          }
          

        </Modal.Body>
      </Modal>
    </>
  );
};
export default BookDownloadModal;
